module.exports = __webpack_public_path__ + "img/oufu_82x100x12b.prt.4bfaa2cf.jpg";